<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>{{cateName}}</span></div>
			<div class="cate flex-start">
				<div class="cate-title">分类：</div>
				<div class="cate-right flex-start flex-center flex-wrap">
					<div :class="0 == cateId?'active':''" :key="0" @click="changeCate('', '全部')">全部</div>
					<div v-for="item in cateList" :class="item.id == cateId?'active':''" :key="item.id" @click="changeCate(item.id, item.name)">{{item.name}}</div>
				</div>
				<div class="order-price" @click="changeSort">价格<i class="el-icon-sort-down" v-if="sortType == 2"></i><i class="el-icon-sort-up" v-if="sortType == 1"></i></div>
			</div>
			<div class="goods-list flex-start flex-wrap" v-if="newGoods.length > 0">
				<goods-item v-for="item in newGoods" :info="item" :key="item.id"></goods-item>
			</div>
			
			<noData v-if="newGoods.length == 0 && isLoad == true" msg="对不起，对应商品分类或筛选组合下没有商品"></noData>
			
			<div class="page" v-if="total > 0">
			    <el-pagination @current-change="getPageList" :current-page="page" :page-size="limit" layout="total, prev, pager, next" :total="total"></el-pagination>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import goodsItem from '@/components/goodsItem.vue'
import noData from '@/components/noData.vue'
import {getCateList,getGoodslist} from "@/api/index"
export default {
	name: 'index',
	components:{
		goodsItem,
		noData
	},
	data(){
		return {
			cateList:[],
			newGoods:[],
			cateId:0,
			page:1,
			limit:16,
			total:0,
			isLoad:false,
			cateName:"",
			sortType:1,
			catePId:0
		}
	},
	mounted() {
		this.catePId = this.$route.query.pid || "";
		this.cateId = this.$route.query.id || "";
		this.cateName = this.$route.query.cate_name || "全部";
		this.isLoad = false;
		this.getCate();
		this.getList();
	},
	methods:{
		getCate(){
			getCateList({parentId:this.catePId}).then(res=>{
				if(res.code == 1000){
					this.cateList = res.data;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getList(){
			getGoodslist({condition:{type:this.catePId,secondType:this.cateId!=0?this.cateId:'',sort:2,sortType:this.sortType},page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.newGoods = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			this.getList();
		},
		//切换类别
		changeCate(id, name){
			this.isLoad = false;
			this.cateId = id;
			this.cateName = name;
			this.page = 1;
			this.getList();
		},
		changeSort(){
			this.sortType = this.sortType == 1?2:1;
			this.page = 1;
			this.isLoad = false;
			this.getList();
		}
	}
}
</script>

<style lang="scss" scoped>
	.goods-list{
		min-height: calc(100vh - 600px);
	}
	.cate{
		width: 1320px;
		background: #FFFFFF;
		padding: 8px 40px;
		margin-bottom: 20px;
		box-sizing: border-box;
		.cate-title{
			height: 22px;
			font-size: 16px;
			line-height: 22px;
			color: #070B13;
			margin: 8px 0px;
			opacity: 0.4;
			flex: 0 0 60px;
		}
		.cate-right{
			width: 100%;
			div{
				height: 22px;
				border-radius: 4px;
				padding: 0px 8px;
				font-size: 32rpx;
				line-height: 22px;
				text-align: center;
				color: #070B13;
				margin: 8px 25px 8px 0px;
				cursor: pointer;
			}
			.active{
				color: #fff;
				background: #E91A12;
				cursor: pointer;
			}
		}
		.order-price{
			height: 22px;
			font-size: 16px;
			line-height: 22px;
			color: #E91A12;
			margin: 8px 0px;
			flex: 0 0 60px;
			text-align: right;
			cursor: pointer;
		}
	}
</style>
